var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 10 15"}},_vm.$listeners),[_c('path',{attrs:{"fill":"#101B31","d":"M7.866 9.738c2-1.155 2-4.042 0-5.197L0 0v14.28z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }